const cardBlacklist = {
  header: {
    btnCreate: 'Criar',
  },

  forms: {
    header: {
      create: {
        title: 'Criar',
      },
      update: {
        title: 'Atualizar',
      },
    },
    create: {
      success: 'O cartão na lista negra foi adicionado!',
      failure: 'Não foi possível criar um cartão na lista negra',
      header: 'Criar item da lista negra de cartões',
      footer: {
        submit: 'Enviar',
      },
    },
    update: {
      footer: {
        submit: 'Atualizar',
      },
    },
    sections: {
      details: {
        header: 'Detalhes',
        fields: {
          number: 'Número do cartão',
        },
      },
    },
  },
  table: {
    headers: {
      number: 'Número do cartão',
      site: 'Local',
    },
    actions: {
      delete: {
        modal: {
          header: 'Excluir cartões da lista negra',
          body: 'Você está prestes a excluir {{num}} cartões da lista negra.',
        },
        success: 'Os cartões na lista negra foram excluídos com sucesso',
      },
      create: 'Criar',
    },
    floatingActions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    
  },
};

export default cardBlacklist;
